import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../../Icon';
import styles from '../FileUpload.module.css';
import { getDataTestId } from '../utils/helpers';
export const FilePreview = ({ previewUrl, showClearButton, dataTestId, onRemove }) => {
    const previewTestId = getDataTestId(dataTestId, 'preview');
    const previewImageTestId = getDataTestId(dataTestId, 'preview-image');
    const removeImageButtonTestId = getDataTestId(dataTestId, 'remove-image-button');
    return (_jsxs("div", { className: styles.preview, "data-testid": previewTestId, children: [_jsx("img", { src: previewUrl, alt: 'Preview', "data-testid": previewImageTestId }), showClearButton && (_jsx("button", { type: 'button', className: styles.removeButton, onClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onRemove();
                }, title: 'Remove image', "aria-label": 'Remove image', "data-testid": removeImageButtonTestId, children: _jsx(Icon, { name: 'actionTrash' }) }))] }));
};
